import { useEffect } from "react";

/**
 * SEOHead — sets document.title, meta description, canonical, OG tags, and injects JSON-LD schema.org.
 * No external deps. Cleans up JSON-LD scripts on unmount.
 */
export default function SEOHead({ title, description, path, jsonLd, image }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    if (image) setMeta("property", "og:image", image);

    // Canonical
    if (path) {
      const base = window.location.origin;
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.href = `${base}${path}`;
      setMeta("property", "og:url", canonical.href);
    }

    // JSON-LD (support single or array)
    const nodes = [];
    const items = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    items.forEach((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seo = "1";
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
      nodes.push(s);
    });

    return () => { nodes.forEach((n) => n.remove()); };
  }, [title, description, path, image, JSON.stringify(jsonLd)]);

  return null;
}
